export const environment = {
  production: true,
  previewUrl: 'https://ng-run-preview.firebaseapp.com/',
  hash: '9dab468ce20facb91f0bbc5c8624f053',
  API_URL: 'https://apis.ng-run.com/v1/',
  socketUrl: 'wss://apis.ng-run.com',
};
